import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
} from "react";
import Confetti from "./Confetti";

const ToastContext = createContext(null);
export const useToast = () => useContext(ToastContext);

let counter = 0;

const ICONS = { success: "✓", error: "✕", info: "ℹ", warning: "!" };

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const [celebration, setCelebration] = useState(0);
  const timers = useRef({});

  const remove = useCallback((id) => {
    // mark closing for exit animation, then drop
    setToasts((list) => list.map((t) => (t.id === id ? { ...t, closing: true } : t)));
    if (timers.current[id]) clearTimeout(timers.current[id]);
    timers.current[id] = setTimeout(() => {
      setToasts((list) => list.filter((t) => t.id !== id));
      delete timers.current[id];
    }, 280);
  }, []);

  const notify = useCallback(
    (type, title, msg, duration = 4200) => {
      const id = ++counter;
      setToasts((list) => [...list, { id, type, title, msg }]);
      if (duration > 0) {
        timers.current[`life-${id}`] = setTimeout(() => remove(id), duration);
      }
      return id;
    },
    [remove]
  );

  const celebrate = useCallback(() => setCelebration((c) => c + 1), []);

  // Convenience helpers
  const api = {
    notify,
    success: (title, msg) => notify("success", title, msg),
    error: (title, msg) => notify("error", title, msg),
    info: (title, msg) => notify("info", title, msg),
    warning: (title, msg) => notify("warning", title, msg),
    celebrate,
    remove,
  };

  return (
    <ToastContext.Provider value={api}>
      {children}
      <Confetti trigger={celebration} />
      <div className="toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.type} ${t.closing ? "closing" : ""}`} onClick={() => remove(t.id)}>
            <div className="t-ico">{ICONS[t.type]}</div>
            <div className="t-body">
              <div className="t-title">{t.title}</div>
              {t.msg ? <div className="t-msg">{t.msg}</div> : null}
            </div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
